import React from 'react'

export const IconPushNotifications = (props={}) => {
	const { size=20, imgSize=20 } = props
	return <>
		<svg width={`${size}px`} height={`${size}px`} viewBox={`0 0 ${imgSize} ${imgSize}`} stroke="currentColor" fill="currentColor" strokeWidth="0" xmlns="http://www.w3.org/2000/svg">
			<g clipPath="url(#clip0_536_6263)">
				<path d="M19.9998 10L1.6665 0.833374L4.99984 10L1.6665 19.1667L19.9998 10ZM3.91317 3.35421L16.3048 9.55004L6.01742 9.14171L3.91317 3.35421ZM6.00175 10.9018L16.4748 10.365L3.91317 16.6458L6.00175 10.9018Z" />
			</g>
			<defs>
				<clipPath id="clip0_536_6263">
					<rect width="20" height="20"/>
				</clipPath>
			</defs>
		</svg>
	</>
}
